// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"cd3107b9","317":"2e399c39","478":"dcfd4dad","754":"b2722833"}[chunkId] + ".chunk.js";
};